export default [
  {
    path: '/approve/update/:id',
    name: 'ApproveUpdate',
    component: () => import('@/views/Approve/ApproveUpdate'),
    redirect: {
      name: 'ApproveUpdate_main'
    },
    children: [
      {
        path: 'main',
        name: 'ApproveUpdate_main',
        component: () => import('@/components/approve/ApproveUpdateMain')
      },
      {
        path: 'controls',
        name: 'ApproveUpdate_controls',
        component: () => import('@/components/approve/ApproveUpdateControls')
      },
      {
        path: 'responsibles',
        name: 'ApproveUpdate_responsibles',
        component: () => import('@/components/approve/ApproveUpdateResponsibles')
      }
    ]
  }
]
